export default "__VITE_ASSET__B4My827U__"